import { http } from '../../config/axios'

export default function postMotorCreditoFormula(motorCreditoFormula: any): Promise<string> {
  return http
    .post('api/motorcreditoformula', motorCreditoFormula)
    .then((res) => {
      return res.data as string
    })
    .catch((error) => {
      console.error('Erro postMotorCreditoFormula', error)
      throw Error(error.response.data)
    })
}
